export default __webpack_public_path__ + "static/media/information--caravan-parking--g1.18735370.png";